export default "__VITE_ASSET__u9Kn_AeY__"